import { Component, Inject, OnInit } from '@angular/core';
import { ChannelService } from '@app/data/services/channel.service';
import { catchError, finalize, tap } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { of } from 'rxjs';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-export-channel',
    templateUrl: './export-channel.component.html',
    styleUrls: ['./export-channel.component.scss'],
    standalone: false,
})
export class ExportChannelComponent implements OnInit {
    isSubmitting = false;
    errorMessage;
    checkForm = false;
    form: FormGroup;

    exportTypes = ['json', 'csv'];

    constructor(
        private channelService: ChannelService,
        private formBuilder: FormBuilder,
        public dialogRef: MatDialogRef<ExportChannelComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            offset: [0, [Validators.required, Validators.min(0)]],
            count: [25, [Validators.required, Validators.min(1)]],
            type: 'json',
        });
    }

    close() {
        this.dialogRef.close();
    }

    exportChannel() {
        this.isSubmitting = true;

        this.channelService
            .export(this.data.channelId, this.form.value.offset, this.form.value.count, this.form.value.type)
            .pipe(
                finalize(() => (this.isSubmitting = false)),
                tap((data) => {
                    const blob = new Blob([data], { type: 'text/csv' });

                    const elem = window.document.createElement('a');
                    elem.href = window.URL.createObjectURL(blob);
                    elem.download = 'export_channel' + this.data.channelId + '.' + this.form.value.type;
                    document.body.appendChild(elem);
                    elem.click();
                    document.body.removeChild(elem);
                }),
                catchError((error) => {
                    this.errorMessage = <any>error;
                    return of(error);
                }),
            )
            .subscribe();
    }
}
